import { useEffect, useRef, useState } from 'react';
import { useLang } from '../LangContext';
import translations from '../i18n';
import content from '../content.json';

const pub = process.env.PUBLIC_URL;

const LOGOS = [
  { name: 'Parco Nazionale Museo delle Miniere del Monte Amiata', src: `${pub}/PARCONAZIONALE-Logo.png` },
  { name: 'Parco Museo Minerario Abbadia San Salvatore', src: `${pub}/PARCOMUSEO-Logo.png` },
  { name: 'ISIA Firenze', src: `${pub}/ISIA-logo.svg` },
  { name: 'Cherubini', src: `${pub}/Logo-CHERUBINI.jpg` },
  { name: 'Spirith', src: `${pub}/SPIRITH-logo.svg` },
  { name: 'Mrk Design Studios', src: `${pub}/MRK-DESIGN-LOGO.svg` },
  { name: 'RU.DE. ETS', src: `${pub}/RUDE-Logo.svg` },
  { name: 'Groove', src: `${pub}/Groove-logo.png` },
];

export default function Partner() {
  const { lang } = useLang();
  const t = translations[lang].partner;
  const trackRef = useRef(null);
  const [paused, setPaused] = useState(false);
  const partner = content.partner;

  const URL_MAP = {};
  partner.forEach(p => { if (p.url) URL_MAP[p.name] = p.url; });

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    let pos = 0;
    let raf;
    const step = () => {
      if (!paused) {
        pos += 0.5;
        const half = track.scrollWidth / 2;
        if (pos >= half) pos = 0;
        track.style.transform = `translateX(-${pos}px)`;
      }
      raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [paused]);

  const allLogos = [...LOGOS, ...LOGOS];

  return (
    <section id="partner" style={{ padding: '100px 0', background: '#ffffff', overflow: 'hidden' }}>
      <div style={{ padding: '0 40px' }}>
        <h2 className="section-title reveal" style={{ color: 'var(--red)' }}>{t.title}</h2>
      </div>

      <div style={{ overflow: 'hidden', padding: '20px 0' }}
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <div ref={trackRef} style={{ display: 'flex', alignItems: 'center', gap: '80px', width: 'max-content', willChange: 'transform' }}>
          {allLogos.map((logo, i) => {
            const url = URL_MAP[logo.name];
            const Tag = url ? 'a' : 'div';
            const linkProps = url ? { href: url, target: '_blank', rel: 'noopener noreferrer' } : {};
            return (
              <Tag key={i} {...linkProps} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', filter: 'grayscale(100%)', opacity: 0.5, transition: 'all 0.4s ease', flexShrink: 0, cursor: url ? 'none' : 'default', textDecoration: 'none' }}
                onMouseEnter={e => { e.currentTarget.style.filter = 'grayscale(0%)'; e.currentTarget.style.opacity = '1'; }}
                onMouseLeave={e => { e.currentTarget.style.filter = 'grayscale(100%)'; e.currentTarget.style.opacity = '0.5'; }}
              >
                <img src={logo.src} alt={logo.name} style={{ height: '70px', maxWidth: '180px', objectFit: 'contain' }} />
              </Tag>
            );
          })}
        </div>
      </div>
    </section>
  );
}
